import moment from 'moment';
let searchDate = moment().startOf('year').format('YYYY');
export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), //페이지 정보

	srchMm01List: [], //검색 판매월 셀렉트박스
	carScnList: [], //검색 차량구분 셀렉트박스
	pacScnList: [], //검색 승상구분 셀렉트박스
	srchMm02List: [], //검색 조건월 셀렉트박스
	saleRegnList: [], //검색 판매지역 셀렉트박스
	flclSpcList: [], //검색 연료전지사양 셀렉트박스
	cTypeList: [], //검색 클레임타입 셀렉트박스
	phmnCdList: [], //검색 현상코드 셀렉트박스
	partTypeList: [], //검색 부품유형 셀렉트박스
	useTermList: [], //검색 사용기간 셀렉트박스
	carTypeNmList: [], //검색 차종유형 셀렉트박스
	prcsStepList: [], //조회조건 처리단계
	prcsRsltList: [], //조회조건 처리결과
	idxScnList: [], //지수구분 처리결과
	ceqTypeList: [], //정비유형
	grdList: [], //그리드리스트
	dayCols: [] //그리드 컬럼(년월컬럼)
};

function SEARCH_PARAMS() {
	return {
		srchMm01: '', //판매월
		carScn: '', //차량구분
		pacScn: '', //승상구분
		srchMm02: '', //조건월
		partNo: '', //품번
		roNo: '', //RO No
		prtlSbc: '', //특이사항검색
		strtTotCst: '', //비용(from)
		endTotCst: '', //비용(to)
		saleRegn: '', //판매지역
		flclSpc: '', //연료전지사양
		cType: '', //클레임타입
		phmnCd: '', //현상코드
		opCd: '', //작업코드
		opCdNm: '', //작업코드
		useTerm: '', //사용기간
		check: '', //누적
		carTypeNm: '', //차종유형

		strtMm01: '', //strtMm01
		endMm01: '', //endMm01
		strtMm02: '', //strtMm02
		endMm02: '', //endMm02
		prcStepGb: '', //처리단계
		prcRsltCd: '', //처리결과
		cmpnNo: '', //캠페인번호,
		partType: '', //부품유형
		idxScn: '', //지수구분
		m3IdxScn: '',
		ceqType: '' //정비유형
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
